import React from 'react';

const CancellationAndRefund = () => {
  return (
    <div className="policy-page-container">
      {/* Breadcrumb Section */}
      <div className="policy-breadcrumb">
        <div className="breadcrumb-content">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb-list">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Cancellation and Refund Policy
              </li>
            </ol>
          </nav>
          <h1 className="breadcrumb-title">Cancellation and Refund Policy</h1>
        </div>
      </div>

     <div className="policy-wrapper">
        <div className="policy-content">
          {/* Header Section */}
          <header className="policy-header">
            <p className="policy-update-date"><strong>Updated effective from 1st April, 2022</strong></p>
            <div className="policy-notice-banner">
              <h2>Thank you for choosing our KYC & Security Consulting Services.</h2>
              <p>
                Please read the following policy carefully before proceeding with any engagement or payment for our compliance services.
              </p>
            </div>
          </header>

          {/* Policy Sections */}
          <div className="policy-sections">
            <section className="policy-section">
              <h2>1. Cancellations</h2>
              <p>
                Once a consulting engagement has been initiated or work has commenced on your KYC/AML compliance assessment, it cannot be canceled automatically through the system.
              </p>
              <p>
                If you booked a consultation in error or need to cancel your engagement, please contact our support team immediately
                at <strong>sales@payinfintech.com</strong> with full details of your engagement (consultation ID, date, service type, and reason for cancellation).
              </p>
              <p>
                Cancellation requests will be reviewed on a case-by-case basis and may be accepted only if the work has not yet commenced or resources have not been allocated to your project.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Refunds</h2>
              <p>Refunds are issued only in cases where:</p>
              <ul>
                <li>The payment was processed but the consulting service could not be delivered due to technical issues or system errors.</li>
                <li>The engagement was canceled before any compliance assessment or API integration work began.</li>
                <li>The service purchased was not delivered within the committed timeframe without prior notice.</li>
              </ul>
              <p>
                Once approved, refunds will be processed within <strong>7–10 business days</strong>, depending on your bank or payment provider.
              </p>
              <p>
                Refunds will be credited to the <strong>original mode of payment</strong> only.
              </p>
              <p>
                We are not responsible for any delays caused by the bank or payment gateway.
              </p>
            </section>

            <section className="policy-section">
              <h2>3. No Refund Conditions</h2>
              <p>Refunds will not be provided in the following cases:</p>
              <ul>
                <li>If the KYC/AML consulting service or compliance assessment was delivered as promised.</li>
                <li>If the engagement was for a non-refundable consultation package or compliance audit.</li>
                <li>If the client fails to provide required compliance information or cancels after work has commenced.</li>
                <li>If regulatory requirements change after the consultation is delivered.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Disputes</h2>
              <p>
                In case of disputes regarding any compliance consultation or payment, please contact our support within <strong>48 hours</strong> of the engagement. We will investigate and assist you promptly.
              </p>
            </section>

            <section className="policy-section">
              <h2>5. Contact Us</h2>
              <p>For any questions about cancellations or refunds regarding our KYC/Security services, please reach out to us at:</p>
              <div className="contact-info">
                <p>📧 <strong>sales@payinfintech.com</strong></p>
                {/* <p>📞 <strong>[Your customer care number]</strong></p> */}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationAndRefund;